module.exports = __webpack_public_path__ + "img/Dataimg.a06abe4d.png";